const timings = [
  {
    icon: "ri-flight-takeoff-line",
    title: "PBI & FLL Airport Departures",
    desc: "Deerfield Beach travelers use Palm Beach International Airport (PBI) about 20 miles north and Fort Lauderdale-Hollywood International Airport (FLL) about 15 miles south. We recommend having your passport in hand at least 3–4 weeks before any international flight to avoid last-minute stress.",
  },
  {
    icon: "ri-ship-line",
    title: "Cruise Departures from Port Everglades & Miami",
    desc: "Port Everglades in Fort Lauderdale is just 15 miles south of Deerfield Beach, and PortMiami is about 35 miles south. Many cruises to the Bahamas, Eastern and Western Caribbean depart weekly. Closed-loop cruises may not require a passport, but we strongly recommend carrying one for emergencies and unexpected itinerary changes.",
  },
  {
    icon: "ri-sun-line",
    title: "Seasonal & Snowbird Travel",
    desc: "Deerfield Beach has a large seasonal resident population. Many snowbirds plan extended European or South American trips during the spring and summer months. Start your renewal 3–5 months ahead of departure to avoid peak-season delays.",
  },
  {
    icon: "ri-parent-line",
    title: "Family Vacation Timing",
    desc: "Spring break and summer are peak travel times for Deerfield Beach families heading to the Caribbean, Europe, or Central America. Child passport processing takes longer and requires both parents' involvement. Start at least 8–10 weeks in advance.",
  },
  {
    icon: "ri-briefcase-line",
    title: "Business Travel from Broward County",
    desc: "Professionals commuting from Deerfield Beach to Latin America, Canada, or Europe for business should keep passports valid at least 6 months beyond their return date. Many countries enforce the 6-month validity rule strictly.",
  },
  {
    icon: "ri-calendar-event-line",
    title: "Last-Minute Emergency Trips",
    desc: "Family emergencies, urgent business meetings, or unexpected opportunities can require travel within days. Our 24-hour emergency service is designed for exactly these situations — just start online and ship your documents overnight.",
  },
];

export default function DeerfieldBeachTravelTimingSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Travel Planning</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            When to Start Your Passport in Deerfield Beach
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Broward County travelers fly from PBI and FLL, cruise from Port Everglades, and vacation across the globe. Here's when you should start your passport application based on your travel plans.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {timings.map((t, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-white rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <i className={`${t.icon} text-[#F6C344] text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm mb-1">{t.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{t.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}